module.exports = __webpack_public_path__ + "static/img/thumb_2.e1f287e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_2.png
// module id = XhmV
// module chunks = 0